import React from "react";

import Icon from "@components/icon";

export default function Mute(props) {
  const { muted, onClick } = props;

  return (
    <div className="VideoContainer-muteIcon" onClick={onClick}>
      <Icon name={muted ? "microphone-slash" : "microphone"} />
    </div>
  );
}
